"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactColor = require("react-color");

var _common = require("react-color/lib/components/common");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _color = _interopRequireDefault(require("react-color/lib/helpers/color"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    fontFamily: "Akkurat Mono, monospace",
    backgroundColor: props => {
      return props.backgroundColor;
    },
    color: props => {
      return props.color;
    },
    "& input": {
      border: "none",
      backgroundColor: "transparent",
      color: "inherit",
      fontFamily: "inherit",
      fontSize: "inherit",
      lineHeight: "1",
      width: "100%",
      minHeight: theme.spacing(7),
      textAlign: "center"
    }
  }
}));

const ColorInput = ({
  className,
  hex,
  rgb,
  hsl,
  hsv,
  onChange
}) => {
  const handleChange = ({
    hex
  }, e) => {
    if (!_color.default.isValidHex(hex)) {
      return false;
    }

    onChange && onChange({
      hex: hex
    });
  };

  const getContrastColor = () => {
    if (!_color.default.isValidHex(hex)) {
      return false;
    }

    if (hex === 'transparent') {
      return 'rgba(0,0,0,0.4)';
    }

    const yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
  };

  const classes = useStyles({
    backgroundColor: hex,
    color: getContrastColor(hex)
  });
  return _react.default.createElement("div", {
    className: className || classes.root
  }, _react.default.createElement(_common.EditableInput, {
    hideLabel: true,
    label: "hex",
    placeholder: "HEX",
    value: hex,
    onChange: handleChange
  }));
};

var _default = (0, _reactColor.CustomPicker)(ColorInput);

exports.default = _default;
module.exports = exports.default;